export const REPLACE_DISTRESSED_CATEGORIES = "REPLACE_DISTRESSED_CATEGORIES";
export const SET_DISTRESSED_CATEGORIES_PAGESIZE = "SET_DISTRESSED_CATEGORIES_PAGESIZE";
export const SET_DISTRESSED_CATEGORIES_PAGENUMBER = "SET_DISTRESSED_CATEGORIES_PAGENUMBER";
export const SET_DISTRESSED_CATEGORIES_TEXTFILTER = "SET_DISTRESSED_CATEGORIES_TEXTFILTER"

export const replaceDistressedCategories = (values, totalResults, totalPage) => ({
    type: REPLACE_DISTRESSED_CATEGORIES,
    distressedCategories: values,
    totalResults,
    totalPage
});

export const setPageSize = (pageSize) => ({
    type: SET_DISTRESSED_CATEGORIES_PAGESIZE,
    pageSize
});
export const setTextFilter = (textFilter) => ({
    type: SET_DISTRESSED_CATEGORIES_TEXTFILTER,
    textFilter
});
export const setPageNumber = (pageNumber) => ({
    type: SET_DISTRESSED_CATEGORIES_PAGENUMBER,
    pageNumber
});